export default __webpack_public_path__ + "static/media/bedroom.8992ff28.png";